import { Star } from "lucide-react";
import { useState } from "react";

/** Display or input star rating. Set `onChange` to make it interactive. */
export function StarRating({ value = 0, onChange, size = 16, className = "" }) {
  const [hover, setHover] = useState(0);
  const interactive = typeof onChange === "function";
  const display = hover || value;
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} role={interactive ? "radiogroup" : undefined} aria-label={`Rating ${value} of 5`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= display;
        return (
          <button
            key={n}
            type="button"
            data-testid={interactive ? `star-${n}` : undefined}
            disabled={!interactive}
            onClick={() => interactive && onChange(n)}
            onMouseEnter={() => interactive && setHover(n)}
            onMouseLeave={() => interactive && setHover(0)}
            className={`p-0.5 rounded-sm transition-transform ${interactive ? "hover:scale-110 cursor-pointer" : "cursor-default"}`}
            aria-label={`${n} star${n === 1 ? "" : "s"}`}
          >
            <Star
              width={size}
              height={size}
              strokeWidth={1.5}
              className={filled ? "text-[#B58B47] fill-[#B58B47]" : "text-stone-300"}
            />
          </button>
        );
      })}
    </div>
  );
}
